import { hiringManagerJobsConstants } from "../../_constants";
import axiosInstance from "../../../_helpers/axiosInstance";
import config from "../../../_config/config";
import { showSuccessMessage, showWarningMessage } from "../../../_uiComponents/ShowMessageSnack";

// create job
export const create_job_hiring_manager_action = (data) => async (dispatch) => {
  dispatch({
    type: hiringManagerJobsConstants.CREATE_JOB_HIRING_MANAGER_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.post(
      config.hiringManager.createJob,
      data
    );
    if (response.status) {
      dispatch({
        type: hiringManagerJobsConstants.CREATE_JOB_HIRING_MANAGER_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: hiringManagerJobsConstants.CREATE_JOB_HIRING_MANAGER_ACTION_FAILURE,
      payload: e.msg,
    });
    showWarningMessage(e?.msg)
  }
};

//update job
export const update_job_hiring_manager_action =
  (data, id) => async (dispatch) => {
    dispatch({
      type: hiringManagerJobsConstants.UPDATE_JOB_HIRING_MANAGER_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.put(
        config.hiringManager.updateJob.replace(":id", id),
        data
      );
      if (response.status) {
        dispatch({
          type: hiringManagerJobsConstants.UPDATE_JOB_HIRING_MANAGER_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: hiringManagerJobsConstants.UPDATE_JOB_HIRING_MANAGER_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e?.msg)
    }
  };

//delete job
export const delete_job_hiring_manager_action = (id) => async (dispatch) => {
  dispatch({
    type: hiringManagerJobsConstants.DELETE_JOB_HIRING_MANAGER_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.delete(
      config.hiringManager.updateJob.replace(":id", id)
    );
    if (response.status) {
      dispatch({
        type: hiringManagerJobsConstants.DELETE_JOB_HIRING_MANAGER_ACTION_SUCCESS,
        payload: response.data,
      });
      showSuccessMessage("Jobs Successfully deleted!");
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: hiringManagerJobsConstants.DELETE_JOB_HIRING_MANAGER_ACTION_FAILURE,
      payload: e.msg,
    });
    showWarningMessage("unable to delete job");
  }
};

//get all jobs
export const get_jobs_hiring_manager_action = () => async (dispatch) => {
  dispatch({
    type: hiringManagerJobsConstants.GET_JOBS_HIRING_MANAGER_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.get(config.hiringManager.jobsList);
    if (response.status) {
      dispatch({
        type: hiringManagerJobsConstants.GET_JOBS_HIRING_MANAGER_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: hiringManagerJobsConstants.GET_JOBS_HIRING_MANAGER_ACTION_FAILURE,
      payload: e.msg,
    });
  }
};

//get job details
export const get_job_details_hiring_manager_action =
  (id) => async (dispatch) => {
    dispatch({
      type: hiringManagerJobsConstants.GET_JOB_DETAILS_HIRING_MANAGER_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        config.hiringManager.jobDetail.replace(":id", id)
      );
      if (response.status) {
        dispatch({
          type: hiringManagerJobsConstants.GET_JOB_DETAILS_HIRING_MANAGER_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: hiringManagerJobsConstants.GET_JOB_DETAILS_HIRING_MANAGER_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };

//get job details

export const get_job_title_hiring_manager_action =
  () => async (dispatch) => {
    dispatch({
      type: hiringManagerJobsConstants.GET_JOB_TITLE_HIRING_MANAGER_ACTION_REQUEST,
    });
    try {
      dispatch({
        type: hiringManagerJobsConstants.GET_JOB_TITLE_HIRING_MANAGER_ACTION_SUCCESS,
        payload: null,
      });
    } catch (e) {
      dispatch({
        type: hiringManagerJobsConstants.GET_JOB_TITLE_HIRING_MANAGER_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  }; 

export const set_job_title_hiring_manager_action =
  (data) => async (dispatch) => {
    dispatch({
      type: hiringManagerJobsConstants.SET_JOB_TITLE_HIRING_MANAGER_ACTION_REQUEST,
    });
    try {
      dispatch({
        type: hiringManagerJobsConstants.SET_JOB_TITLE_HIRING_MANAGER_ACTION_SUCCESS,
        payload: data,
      });
    } catch (e) {
      dispatch({
        type: hiringManagerJobsConstants.SET_JOB_TITLE_HIRING_MANAGER_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };

//get job details
export const get_all_added_skills_hiring_manager_action =
  () => async (dispatch) => {
    dispatch({
      type: hiringManagerJobsConstants.GET_ALL_ADDED_SKILLS_HIRING_MANAGER_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        config.hiringManager.allAddedSkills
      );
      if (response.status) {
        dispatch({
          type: hiringManagerJobsConstants.GET_ALL_ADDED_SKILLS_HIRING_MANAGER_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: hiringManagerJobsConstants.GET_ALL_ADDED_SKILLS_HIRING_MANAGER_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };


  